export default "__VITE_ASSET__BrIw7POs__"